const isBrowser = typeof window !== "undefined";

class DomEnvironment {
  touch = isBrowser && testTouch.call(this);
  iOS = isBrowser && testIOS.call(this);
  isSafari = isBrowser && testSafari.call(this);
  isChrome = isBrowser && testChrome.call(this);
}

function testTouch() {
  return "ontouchstart" in window;
}

function testIOS() {
  // Navigator Platform is deprecated
  // Recommended alternative is to use user agent data
  // https://docs.w3cub.com/dom/navigator/platform
  return (
    ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
      navigator.platform,
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

function testSafari() {
  return (
    navigator.vendor.match(/apple/i) &&
    !/crios/i.test(navigator.userAgent) &&
    !/fxios/i.test(navigator.userAgent)
  );
}

function testChrome() {
  return navigator.userAgent.includes("Chrome");
}

const domEnvironment = new DomEnvironment();
export { DomEnvironment, domEnvironment };
